import React from "react";

function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-[#F5F7FB] py-4">
      <div className="mx-auto max-w-6xl px-4 text-center text-[11px] text-[#6E7B86]">
        Copyright © {new Date().getFullYear()} femtyz.
      </div>
    </footer>
  );
}

export default Footer;